import { makeStyles } from 'tss-react/mui';

export const useProductPricesV2Styles = makeStyles()((theme) => ({
  root: {
    border: 'none',
    maxHeight: '100%',
    overflowY: 'hidden',
    '& .MuiTableCell-head': {
      border: 'none',
    },
    '& .MuiTableCell-root': {
      border: 'none',
      textAlign: 'right',
      verticalAlign: 'bottom',
      whiteSpace: 'nowrap',
    },
    '& .MuiTableCell-sizeSmall': {
      padding: '4px 6px',
    },
  },
  tableCell: {
    '&:first-child': { paddingLeft: '0px !important' },
    '&:last-child': { paddingRight: '0px !important' },
  },
  lastRow: {
    '& .MuiTableCell-sizeSmall': {
      padding: '4px 6px 12px 6px',
    },
  },
  firstRow: {
    '& .MuiTableCell-sizeSmall': {
      padding: '12px 6px 4px 6px',
    },
  },
  productPricesContainer: {
    gap: 12,
  },
  productPriceContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    gap: 8,
    textAlign: 'right',
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightRegular as number,
  },
  priceCompositionLabel: {
    color: theme.palette.grey[500],
  },
}));
